// @ts-check
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { formatDay, formatRupees, label, termsSummary } from '../../utils/wholesale';
import { card } from './shared';

const TH = 'px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase whitespace-nowrap';

/** @param {{data: {reference_tag: number, ranked: any[], excluded: any[]} | null}} props */
const QuoteRanking = ({ data }) => {
  if (!data) return null;
  const row = (q, rank) => (
    <tr key={q.id} className={q.excluded_reason ? 'bg-red-50/60 dark:bg-red-950/20' : 'hover:bg-muted/50'}>
      <td className="px-4 py-3 text-sm text-muted-foreground">{rank ?? <AlertTriangle size={16} className="text-red-600" />}</td>
      <td className="px-4 py-3 text-sm font-medium">
        <Link to={`/wholesale/${q.partner_id}`} className="hover:underline">
          {q.partner_name}
        </Link>
        <div className="text-xs text-muted-foreground font-normal">{[q.city, label(q.price_tier) + ' tier'].filter(Boolean).join(' · ')}</div>
      </td>
      <td className="px-4 py-3 text-sm">{label(q.model)}</td>
      <td className="px-4 py-3 text-sm">
        {termsSummary(q)}
        {q.excluded_reason && <div className="text-xs text-red-700 dark:text-red-400 mt-0.5">{q.excluded_reason}</div>}
      </td>
      <td className="px-4 py-3 text-sm text-right font-semibold">{formatRupees(q.net_realisation_per_piece)}</td>
      <td className="px-4 py-3 text-sm whitespace-nowrap">{formatDay(q.received_at)}</td>
      <td className="px-4 py-3 text-sm">{label(q.status)}{q.is_counter ? ' (our counter)' : ''}</td>
    </tr>
  );
  return (
    <div>
      <p className="text-sm text-muted-foreground mb-3">
        Net per piece KAAY receives on a {formatRupees(data.reference_tag)} tag, after the cost of money and any fees. Read it beside the
        tier: a door that takes only the lower tier scores lower than its real value.
      </p>
      {data.ranked.length + data.excluded.length === 0 ? (
        <div className={`${card} p-12 text-center text-muted-foreground`}>No open quotes yet. Quotes appear here once you log them on a partner.</div>
      ) : (
        <div className={`${card} overflow-x-auto`}>
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className={TH}>#</th>
                <th className={TH}>Partner</th>
                <th className={TH}>Model</th>
                <th className={TH}>Terms</th>
                <th className={`${TH} text-right`}>Net / piece</th>
                <th className={TH}>Received</th>
                <th className={TH}>Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {data.ranked.map((q, i) => row(q, i + 1))}
              {data.excluded.map((q) => row(q, null))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default QuoteRanking;
